export enum ActivityType{
    ZelfBedacht = 0,
    EigenInvulling,
    ZelfBedachtMetMethode,
    ObvTemplate,
    ZelfBedachtMetTemplate,
    ZelfBedachtMetActiviteit,
    ZelfBedachtMetEigenInvulling,
}